export var ExperienceReservationState;
(function (ExperienceReservationState) {
    ExperienceReservationState["Future"] = "Future";
    ExperienceReservationState["Present"] = "Present";
    ExperienceReservationState["Past"] = "Past";
    ExperienceReservationState["Canceled"] = "Canceled";
})(ExperienceReservationState || (ExperienceReservationState = {}));
export var VoucherFormatEnum = {
    Html: "Html",
    Pdf: "Pdf",
    Unknown: "Unknown",
};
export var VoucherTypeEnum = {
    Standard: "Standard",
    Supplier: "Supplier",
    Unknown: "Unknown",
};
export var ExperienceBookingStatusEnum = {
    Cancelled: "Cancelled",
    Confirmed: "Confirmed",
    Pending: "Pending",
    Unknown: "Unknown",
};
//# sourceMappingURL=experienceItinerary.js.map